export var AccessibilityActions;
(function (AccessibilityActions) {
  let SetTheme = /*#__PURE__*/(() => {
    class SetTheme {
      static {
        this.type = '[A11y] SetTheme';
      }
      constructor(mode) {
        this.mode = mode;
      }
    }
    return SetTheme;
  })();
  AccessibilityActions.SetTheme = SetTheme;
  let SetBrowserTheme = /*#__PURE__*/(() => {
    class SetBrowserTheme {
      static {
        this.type = '[A11y] SetBrowserTheme';
      }
      constructor(mode) {
        this.mode = mode;
      }
    }
    return SetBrowserTheme;
  })();
  AccessibilityActions.SetBrowserTheme = SetBrowserTheme;
  let ConfigurateModule = /*#__PURE__*/(() => {
    class ConfigurateModule {
      static {
        this.type = '[A11y] ConfigurateModule';
      }
      constructor(moduleId, config) {
        this.moduleId = moduleId;
        this.config = config;
      }
    }
    return ConfigurateModule;
  })();
  AccessibilityActions.ConfigurateModule = ConfigurateModule;
  let ApplyModules = /*#__PURE__*/(() => {
    class ApplyModules {
      static {
        this.type = '[A11y] ApplyModules';
      }
      // haveModulesOnlyBeenUpdated indicates if only existing modules have been updated,
      // or if a new module has been added.
      constructor(haveModulesOnlyBeenUpdated) {
        this.haveModulesOnlyBeenUpdated = haveModulesOnlyBeenUpdated;
      }
    }
    return ApplyModules;
  })();
  AccessibilityActions.ApplyModules = ApplyModules;
  let ResetModules = /*#__PURE__*/(() => {
    class ResetModules {
      static {
        this.type = '[A11y] ResetModules';
      }
      // haveModulesOnlyBeenUpdated indicates if only existing modules have been updated,
      // or if a new module has been added.
      constructor() {}
    }
    return ResetModules;
  })();
  AccessibilityActions.ResetModules = ResetModules;
})(AccessibilityActions || (AccessibilityActions = {}));
// export UserActions;